<template>
  <v-dialog
    :value="value"
    transition="dialog-top-transition"
    max-width="600px"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} свойства </v-toolbar>
      <grade-property-card :property="localProperty" :mode="'editor'" :full-view="true" @onPropUpdate="doPropUpdate"/>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark :disabled="saveDisabled" @click="doSave" outlined>
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { UI_SNACKBAR } from '@/store/actions/ui'
import GradePropertyCard from '@/components/modules/references/cards/gradePropertyCard'
export default {
  name: 'refAddGradePropertyDialog',
  components: { GradePropertyCard },
  props: {
    property: {
      type: Object,
      default: function () {
        return {}
      }
    },
    grade: {
      type: Object,
      default: function () {
        return {}
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localProperty: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавить' : 'Сохранить' : ''
      }
    },
    hdrText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавление' : 'Редактирование' : ''
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localProperty) return true
        const noMin = !this.localProperty.PROP_MIN
        const noMax = !this.localProperty.PROP_MAX
        const MMX = this.localProperty.PROP_MAX < this.localProperty.PROP_MIN
        return noMin || noMax || MMX || !this.dataChanged
      }
    },
    dataChanged: {
      get () {
        if (this.dataNew) return true
        return this.property.PROP_UUID !== this.localProperty.PROP_UUID ||
          this.property.PROP_MIN !== this.localProperty.PROP_MIN ||
          this.property.PROP_MAX !== this.localProperty.PROP_MAX ||
          this.property.PROP_KOEFF !== this.localProperty.PROP_KOEFF
      }
    },
    dataNew: {
      get: function () {
        console.log('Requested for dataNew. Initial property is ', this.property, '. Local property is ', this.localProperty)
        return !this.property.PROP_PKUUID
      }
    }
  },
  watch: {
    property (val) {
      console.log('refAddGradePropertyDialog watcher property detected change to ', val)
      console.log('refAddGradePropertyDialog watcher current grade is ', this.grade)
      if (val && val.PROP_PKUUID) {
        // eslint-disable-next-line no-undef
        this.localProperty = structuredClone(val)
      } else {
        console.log('val length is empty object')
        this.localProperty = {}
      }
      console.log('Current lP is ', this.localProperty)
    }
  },
  methods: {
    doSave () {
      console.log('local property is ', this.localProperty)
      const action = this.dataNew ? 'add' : 'update'
      const processorPath = action === 'update' ? '/api/org/references/updGradeProperty.php' : '/api/org/references/addProperty2Grade.php'
      const payload = {
        PROP_PKUUID: this.localProperty.PROP_PKUUID,
        PROP_UUID: this.localProperty.PROP_UUID,
        PROP_MIN: this.localProperty.PROP_MIN,
        PROP_MAX: this.localProperty.PROP_MAX,
        PROP_KOEFF: this.localProperty.PROP_KOEFF || 1,
        GRADE_UUID: this.grade.GRADE_UUID,
        EI_UUID: action === 'add' ? this.localProperty.EI.EI_UUID : this.localProperty.EI_UUID
      }

      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              this.$emit('propertyAdded', [resp.data.data])
            } else {
              this.$emit('propertyUpdate', [resp.data.data])
            }
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doPropUpdate (data) {
      console.log('refAddGradePropertyDialog:: doPropUpdate method called ', data)
      this.localProperty = { ...this.localProperty, ...data }
      console.log('refAddGradePropertyDialog:: doPropUpdate current data is ', this.localProperty)
    }
  },
  mounted () {
    console.log('refAddGradePropertyDialog mounted with property ', this.property)
  }
}
</script>
